import * as utilities from '@/assets/js/utility';

const installUtilities = (Vue, utilities) => {
  const filteredKeys = Object.keys(utilities);

  filteredKeys.forEach(utility => {
    Vue.filter(utility, utilities[utility]);
    Vue.prototype[`$_${utility}`] = utilities[utility];
  });
};

export default {
  install(Vue) {
    installUtilities(Vue, utilities);
  },
};
